import SectionWithSlider from "@components/global/SectionWithSlider"
import {
  linkProductsServices,
  linkProductsServicesCinema,
} from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { imgUrl } from "src/mixins"

function LocationDetailTheaters({ cinemas, locale }) {
  const [trigger, anim] = useScrollAnim()

  return (
    <SectionWithSlider
      sectionName="sc-location-detail-theaters"
      cardType="overlay"
      data={cinemas?.map((item) => ({
        title: item[`title_${locale}`],
        text: item[`description_${locale}`],
        img: imgUrl(item.thumb_image),
        slug: item.slug,
        linkCard: `${linkProductsServicesCinema}/${item.slug}`,
      }))}
      title={translations[`loc_detail_theaters_title_${locale}`]}
      text={translations[`loc_detail_theaters_text_${locale}`]}
      slidesPerViewMobile={1.6}
      slidesPerViewDesktop={1.6}
      hasArrow={cinemas?.length > 1}
      navTheme="light"
      link={linkProductsServices}
      linkText={translations[`loc_detail_theaters_text_btn_${locale}`]}
    />
  )
}

export default LocationDetailTheaters
